export default {
    root:{
        backgroundColor: 'white',
        border: '1px solid black',
        borderRadius: '5px',
        padding: '0.5rem',
        position: 'relative',
        overflow: 'hidden',
        cursor: 'pointer',
        "&:hover svg": {
            opacity: '1'
        }
    },
    colors:{
        backgroundColor: 'lightgrey',
        height: '150px',
        width: '100%',
        borderRadius: '5px',
        overflow: 'hidden'
    },
    title:{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        margin: '0',
        paddingTop: '0.5rem',
        fontSize: '1rem',
        position: 'relative'
    },
    emoji:{
        marginLeft: '0.5rem',
        fontSize: '1.5rem'
    },
    miniColor:{
        height: "25%",
        width: '20%',
        display: "inline-block",
        margin: '0 auto',
        position: 'relative',
        marginBottom: '-3.5px'
    },
    deleteIcon: {
        width: '20px',
        height: '20px',
        color: 'white',
        backgroundColor: 'red',
        position: 'absolute',
        right: '0px',
        top: '0px',
        zIndex: '10',
        padding: '10px',
        opacity: '0'
    }
}